import classNames from 'classnames'
import { ToggleGroupChangeHandler } from '@lounge-fe/ui-kit/src/components/ToggleGroup/types'
import { ChoiceChips, useWizardContext } from '@lounge-fe/ui-kit'
import { StepChoiceChipsProps } from './types'

export const StepChoiceChips = ({
  name,
  options = [],
  className,
}: StepChoiceChipsProps) => {
  const { next } = useWizardContext()

  const onChange: ToggleGroupChangeHandler = (value: string) =>
    next({ [name]: value })

  return (
    <ChoiceChips
      className={classNames(
        'w-full grid grid-cols-1 gap-4',
        options.length % 2 === 0 && 'sm:grid-cols-2',
        className,
      )}
      value={undefined}
      onChange={onChange}
    >
      {options.map(({ value, label }) => (
        <ChoiceChips.Item
          key={value}
          value={value}
          className="min-h-[48px] w-full"
        >
          {label}
        </ChoiceChips.Item>
      ))}
    </ChoiceChips>
  )
}
